import { memo } from 'react';
import { SwitchStyled } from './styled';

interface Props {
  isActive: boolean;
  onSwitch: (checked: boolean) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

const Switch = ({ isLoading, ...props }: Props) => {
  return (
    <SwitchStyled>
      <div
        className={`rule-toggle ${props.isActive && 'active'} ${isLoading ? 'disable' : ''} ${props.isDisabled && 'disable'}`}
        onClick={(e) => {
          e.stopPropagation();
          props.onSwitch(!props.isActive);
        }}
      />
    </SwitchStyled>
  );
};

export default memo(Switch);
